import GraphVerticalBar from './GraphVerticalBar';

export default GraphVerticalBar;
